import { render, staticRenderFns } from "./RestoreTaskDetailsDialog.vue?vue&type=template&id=761a1e7f&scoped=true&"
import script from "./RestoreTaskDetailsDialog.vue?vue&type=script&lang=ts&"
export * from "./RestoreTaskDetailsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RestoreTaskDetailsDialog.vue?vue&type=style&index=0&id=761a1e7f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761a1e7f",
  null
  
)

export default component.exports